(function () {
    angular.module('Directives')
        .directive('expandImageEnabled',expandImageEnabled);

    expandImageEnabled.$inject = ['$uibModal'];
    function expandImageEnabled($uibModal){
        return {
            restrict: 'A',
            scope: {
                expandImageEnabled: '='
            },
            link: expandImageEnabledLink
        };

        function expandImageEnabledLink($scope, $element, $attrs){
            $scope.$watch('expandImageEnabled', function (n) {
                if(n){
                    $element.addClass('pointer');
                    if($element[0].tagName === 'IMG' && ($attrs.src || $attrs.ngSrc)){
                        $element.bind('click', expandHandler);
                    }else{
                        $element.unbind('click', expandHandler);
                    }
                }else{
                    $element.removeClass('pointer');
                    $element.unbind('click', expandHandler);
                }
            });

            function expandHandler(){
                if(!$scope.expandImageEnabled){
                    return false;
                }
                $uibModal.open({
                    animation: true,
                    ariaLabelledBy: 'modal-title',
                    ariaDescribedBy: 'modal-body',
                    template: `
                    <div class="modal-body" style="text-align: center">
                        <img src="${$attrs.src}">
                    </div>`,
                    controller: function ($uibModalInstance) {

                    },
                    controllerAs: 'cm',
                    size: 'md',
                    appendTo: $('body')
                });
            } {

            }
        }
    }
})();


// WEBPACK FOOTER //
// ./js/directives/component/expandImageEnabled.js